import { viemChains } from '@vaultsfyi/common/constants'

export const getChainNameById = (chainId: number) => {
  const chainName = Object.keys(viemChains).find((key) => viemChains[key as keyof typeof viemChains].id === chainId)
  if (!chainName) {
    throw new Error(`Chain with id ${chainId} not found`)
  }
  return chainName
}
